<template>
  <div>
    <Breadcrumbs v-if="meta" :title="meta.translation['en'].name + ' / Project export'"/>

    <b-modal id="modal-list-exports" :title="$t('message.download_old_pdf')" class="theme-modal" no-close-on-backdrop
             hide-footer>
      <div>
        <div class="row mb-2" :key="item.id" v-for="item in exportHistory">
          <div class="col-6" style="display: flex;align-items: center">
            {{ item.created_at | formatDate }}
          </div>
          <div class="col-6">
            <a :href="'https://admin.gameofbusiness.eu/uploads/' + item.file" :download="item.file"
               class="btn btn-primary btn-sm" style="width: 100%">{{ $t('message.download_old_pdf') }}</a>
          </div>
        </div>
      </div>
    </b-modal>


    <div class="text-right p-20 p-t-0 p-b-0" style="height: 38px">

      <svg @click="openExportModal" v-if="exportHistory.length"
           style="width: 24px;height: 24px;margin-right: 10px;cursor: pointer;position: relative;top:9px;"
           xmlns="http://www.w3.org/2000/svg"
           fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"/>
      </svg>


      <b-tooltip target="disabled-button-tooltip" triggers="hover" placement="left" style="border: none !important;">
        {{ $t("message.generate_limit") }}
      </b-tooltip>
      <span id="disabled-button-tooltip">
      <button v-show="exportChecked" class="btn btn-primary" @click="generatePdfDocument" :disabled="disabledButton"
              style="border: none !important;">
        {{ $t('message.generate_pdf') }}
      </button>
        </span>
    </div>

    <div class="container-fluid" style="padding-bottom: 10px;">
      <!--      <h4 v-if="meta" class="mb-5">{{ meta.translation['en'].name }}</h4>-->

      <div v-for="record in dateExport" :key="record.id" class="mb-5">
        <h5 style="font-size: 1.2rem">{{ record.name }}</h5>
        <div class="ml-4 mt-3" v-for="item in record.steps" :key="item.id">
          <h5 style="font-size: 1.0rem">{{ item.name }}</h5>
          <div class="ml-4 mt-3" v-for="last in item.steps" :key="last.id">
            <h5 style="font-size: 1.0rem">{{ last.name }}</h5>
            <div class="ml-4 mt-3" v-for="section in last.sections" :key="section.id">
              <h5 style="font-size: 1.0rem">{{ section.name }}</h5>

              <div style="position: relative;">
                <svg @click="goToAssigment(section)" v-if="section.last && section.last != ''"
                     style="position:absolute;z-index:100;top: 10px;right: 10px;cursor: pointer;width: 24px"
                     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"/>
                </svg>

                <div v-if="section.last && section.last != ''" class="card p-4" v-html="section.last"></div>
                <div class="card p-4" v-if="!section.last">{{ $t('message.data_not_available') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body" v-if="incomeCategory">
        <BudgetSection :show-items="false" :cat="incomeCategory" :budget="defaultBudget"
                       :key="incomeCategory.id"></BudgetSection>
      </div>

      <div class="card-body" v-if="expensesCategory">
        <BudgetSection :show-items="false" :cat="expensesCategory" :budget="defaultBudget"
                       :key="expensesCategory.id"></BudgetSection>
      </div>
      <div class="card-body">
        <BudgetSummary
            v-if="defaultBudget"
            :budget="defaultBudget">
        </BudgetSummary>
      </div>
    </div>
  </div>
</template>


<script>

import BudgetSummary from "../Budget/BudgetSummary";
import BudgetSection from "../Budget/BudgetSection"

export default {
  components: {BudgetSummary, BudgetSection},
  data() {
    return {
      exportChecked: false,
      exportHistory: [],
      dateExport: [],
      meta: null,
      defaultBudget: null,
      incomeCategory: null,
      expensesCategory: null
    }
  },
  async created() {

    let response = await this.$store.dispatch('planExport/loadPlanExport', {
      id: this.$route.params.id,
      lang: this.$i18n.locale
    })

    this.meta = response.data.result.meta[0]
    this.dateExport = response.data.result.data

    let info = await this.$store.dispatch('budget/getAll', this.$route.params.id)

    let mainBudget = info.find((item) => {
      return item.default
    })

    if (mainBudget) {
      this.loadDefault(mainBudget)
    }

    this.loadExportHistory()
  },
  methods: {

    generatePdfDocument: async function () {

      let response = await this.$store.dispatch('planExport/planPdfGenerate', this.meta.id)

      console.log('response', response)
    },

    openExportModal: function () {
      this.$bvModal.show('modal-list-exports')
    },

    loadExportHistory: async function () {

      let response = await this.$store.dispatch('planExport/loadExportHistory', {
        id: this.$route.params.id
      })

      this.exportHistory = response

      this.exportChecked = true

    },

    goToAssigment(section) {

      this.$router.push(
          {
            name: 'ProjectPlan',
            params: {
              id: this.$route.params.id,
              module: section.module_id
            },
            query: {
              'section': section.section_id,
              'assignment': section.assignment_id
            }
          })
    },

    async loadDefault(budget) {

      this.defaultBudget = await this.$store.dispatch("budget/getSingle", budget.id)

      this.incomeCategory = this.defaultBudget.categories.find((cat) => {
        return cat.name == 'Revenue'
      })

      this.expensesCategory = this.defaultBudget.categories.find((cat) => {
        return cat.name == 'Expenses'
      })
    }
  },
  computed: {

    planName: function () {
      return this.meta ? this.meta.transaction : ''
    },
    disabledButton: function () {

      if (this.exportHistory.length) {

        let lastExportTime = this.moment(this.exportHistory[0].created_at)
        let currentTime = this.moment()


        return !(currentTime.diff(lastExportTime, "days") > 7)

      } else {

        return false
      }
    }
  }
};
</script>

<style scoped>
.tooltip {
  border-bottom: none !important;
}
</style>